import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../../shared/services/api.service';
import {EnrollService} from '../../../../shared/services/enroll.service';
import {NfcService} from '../../../../shared/services/nfc.service';
import {FormService} from '@satoris/ngx-satoris';

@Component({
  selector: 'app-activation-step-ask-pin',
  templateUrl: './activation-step-ask-pin.component.html',
  styleUrls: ['./activation-step-ask-pin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationStepAskPinComponent {
  constructor(public api: ApiService, public enroll: EnrollService, public nfc: NfcService, public forms: FormService) {}

  cleanAndSubmit() {
    this.enroll.form.controls[this.enroll.fc.FACE_PICTURE].setValue('');
    this.enroll.submitForm(this.enroll.getCurrentStep());
  }
}
